/**
 * UI strings of the engine and the static page, as one typed dictionary per
 * language. `en` must have exactly the keys of `zh` (typecheck), and the same
 * `{var}` placeholders (messages.test.ts). Level content lives next to its
 * logic with `tr()` instead.
 */
import { isEn } from "./locale";

const zh = {
  "doc.title": "Clerk Simulator｜醫學生見習 RPG",

  "lang.label": "語言",
  "sfx.on": "♪ 音效 開",
  "sfx.off": "♪ 音效 關",
  "title.tag": "醫學生見習 RPG・病人不會等你",
  "title.press": "按任意鍵開始",
  "title.pressSub": "PRESS ANY KEY",
  "title.pa": "院內廣播",
  "title.logged": "對話內容會被記錄，用於改善遊戲與防止濫用",
  "title.best": "最佳評價 {grades}　{done}/{total} 關",
  "title.bestNone": "最佳評價　尚無紀錄",

  "menu.best": "最佳成績",
  "menu.empty": "這一科的關卡還在準備中。",
  "menu.start": "開始",
  "menu.back": "回到關卡列表",
  "menu.levelSub": "{dept}見習　{level}",
  "menu.howto":
    "方向鍵或 WASD 移動，空白鍵查看；也可以直接點地圖上的人或東西走過去。頭上有「?」的人在等你回答，「!」是有新消息。時間會一直走。角色由 Claude 即時生成。",

  "stage.map": "場景地圖",
  "stage.note": "方向鍵移動　空白鍵查看　點地圖也可以走",
  "stage.feedback": "看{name}的回饋",
  "stage.fullMap": "看全圖",
  "stage.zoomIn": "放大",
  "stage.help": "說明（H）",
  "stage.levels": "關卡選擇",
  "stage.levelsArmed": "再按一次回到關卡選擇",
  "stage.end": "結束這關",
  "stage.endArmed": "再按一次確認結束",
  "stage.hintKey": "空白鍵",
  "pad.back": "返回",

  "side.showLog": "展開紀錄 ▲",
  "side.hideLog": "收起 ▼",
  "side.fieldLog": "現場紀錄",
  "side.fieldHint": "走到人或東西旁邊按空白鍵",
  "side.leave": "離開",
  "side.say": "說",
  "side.placeholder": "說點什麼，Enter 送出",
  "side.placeholderShort": "說點什麼",
  "side.thinking": "正在回應",

  "log.you": "你",
  "log.result": "結果",
  "log.scene": "現場",
  "log.sep": "　",
  "log.chan": "［{ch}］",

  "time.min": "+{n} 分",
  "time.idle": "時間流逝",
  "time.action": "動作",
  "time.talk": "對話",
  "time.up": "時間到",

  "zoom.label": "特寫",
  "zoom.close": "關閉（Esc）",
  "zoom.credit": "影像：{credit}",
  "zoom.drawn": "看手繪版",
  "zoom.photo": "看真實影像",
  "zoom.monitor": "生命徵象監視器",

  "call.label": "來電",
  "call.title": "{name} 來電",
  "call.body": "手機在白袍口袋裡震個不停。",
  "call.answer": "接起電話",
  "call.picked": "你接起電話。",

  "help.label": "說明",
  "help.title": "說明　{level}",
  "help.tabMap": "地圖",
  "help.tabRules": "規則",
  "help.mapHead": "地圖上可以互動的地方",
  "help.go": "知道了",
  "help.reopen": "隨時按 H 或底部「說明」再打開。說明開著的時候時間會暫停。",
  "help.you": "你在這",
  "help.timeHead": "時間怎麼走",
  "help.idle": "什麼都不做",
  "help.idleWhen": "每 {sec} 秒",
  "help.idleOr": "（開刀中 6 秒）",
  "help.idleCost": "+1 分",
  "help.walk": "走路",
  "help.walkWhen": "不額外花時間，時鐘照常走",
  "help.walkCost": "＋0",
  "help.talk": "跟人說一句話",
  "help.talkWhen": "等對方回話時時鐘暫停",
  "help.talkCost": "+1～2 分",
  "help.act": "檢查、處置、開醫囑",
  "help.actWhen": "按下去時鐘旁邊會顯示花了多久",
  "help.actCost": "+1～6 分",
  "help.pause": "說明頁、來電、事件橫幅",
  "help.pauseWhen": "這些時候",
  "help.pauseCost": "時鐘暫停",
  "help.noWait": "病人的狀況會跟著時間變化，不會等你。",
  "help.span": "這關從 {start} 開始，最晚到 {end} 交班。",
  "help.ctrlHead": "怎麼操作",
  "help.ctrl1": "方向鍵或 WASD 移動，空白鍵查看面前的東西；也可以直接點地圖上的人或物品走過去。",
  "help.ctrl2": "黃色 ▼：你面前可以互動的東西。",
  "help.ctrl3": "角色頭上：黃色「?」在等你回答，紅色「!」有新消息，白色「…」正在說話。",
  "help.ctrl4": "地圖左上角：別人在等你的事；有倒數條的是有時限的。",
  "help.ctrl5": "右側面板：對話紀錄、可以做的事、打字跟角色說話。",
  "help.ctrl6": "走到病人旁邊會打開特寫畫面，直接點身體或儀器。",
  "help.rulesHead": "這關的特別規則",
  "help.legendSep": "　",

  "end.label": "結局",
  "end.code": "結局 {code}",
  "end.reason": "結局 {code}：{name}",
  "end.toLevels": "回到關卡選擇",
  "end.done": "完成",
  "end.early": "提早結束",

  "fb.good": "做到了",
  "fb.partial": "部分",
  "fb.miss": "漏掉",
  "fb.heading": "{name}的回饋　{level}{ending}",
  "fb.ending": "　結局 {code}：{name}",
  "fb.best": "最好的一刻",
  "fb.next": "下次",
  "fb.over": "這關結束",
  "fb.failed": "評語沒有產生成功。下面是關鍵紀錄。",
  "fb.writing": "{name}正在看你的紀錄，寫評語中⋯⋯",
  "fb.backToLog": "回去看紀錄",
  "fb.factSep": "　／　",

  "err.noKey": "伺服器沒有設定 Claude API 金鑰，角色無法回話。",
  "err.quota": "今天的對話額度用完了，角色暫時無法回話。明天再來，或先結束這關看回饋。",
  "err.noSession": "沒辦法確認你是真人玩家（驗證沒通過）。重新整理頁面再試一次。",
  "err.rate": "對方暫時沒有回應（使用量達上限），稍等再說一次。",
  "err.network": "訊號斷了一下，對方沒聽到。再說一次試試。",
} as const;

const en = {
  "doc.title": "Clerk Simulator: a pixel-art clerkship RPG",

  "lang.label": "Language",
  "sfx.on": "♪ SOUND ON",
  "sfx.off": "♪ SOUND OFF",
  "title.tag": "Med student RPG · Patients don’t wait",
  "title.press": "PRESS ANY KEY",
  "title.pressSub": "OR TAP TO START",
  "title.pa": "PAGING",
  "title.logged": "Conversations are logged to improve the game and prevent abuse",
  "title.best": "BEST {grades} · {done}/{total} LEVELS",
  "title.bestNone": "BEST · NO GRADES YET",

  "menu.best": "Best grade",
  "menu.empty": "Levels for this rotation are still being written.",
  "menu.start": "Start",
  "menu.back": "Back to levels",
  "menu.levelSub": "{dept} clerkship · {level}",
  "menu.howto":
    "Move with the arrow keys or WASD and press Space to interact, or click a person or object on the map to walk there. A “?” over someone’s head means they’re waiting on you; a “!” means news. The clock never stops. Characters are played live by Claude.",

  "stage.map": "Scene map",
  "stage.note": "Arrows to move · Space to interact · click the map to walk",
  "stage.feedback": "{name}’s feedback",
  "stage.fullMap": "Full map",
  "stage.zoomIn": "Zoom in",
  "stage.help": "Help (H)",
  "stage.levels": "Levels",
  "stage.levelsArmed": "Click again to leave",
  "stage.end": "End level",
  "stage.endArmed": "Click again to end",
  "stage.hintKey": "Space",
  "pad.back": "Back",

  "side.showLog": "Show log ▲",
  "side.hideLog": "Hide ▼",
  "side.fieldLog": "Field log",
  "side.fieldHint": "Walk up to someone or something and press Space",
  "side.leave": "Leave",
  "side.say": "Say",
  "side.placeholder": "Say something (Enter to send)",
  "side.placeholderShort": "Say something",
  "side.thinking": "is replying",

  "log.you": "You",
  "log.result": "Result",
  "log.scene": "Scene",
  "log.sep": " · ",
  "log.chan": "[{ch}] ",

  "time.min": "+{n} min",
  "time.idle": "Time passes",
  "time.action": "Action",
  "time.talk": "Talking",
  "time.up": "Time’s up",

  "zoom.label": "Close-up",
  "zoom.close": "Close (Esc)",
  "zoom.credit": "Image: {credit}",
  "zoom.drawn": "Show drawing",
  "zoom.photo": "Show real image",
  "zoom.monitor": "Vital signs monitor",

  "call.label": "Incoming call",
  "call.title": "{name} is calling",
  "call.body": "Your phone won’t stop buzzing in your white coat pocket.",
  "call.answer": "Answer",
  "call.picked": "You pick up.",

  "help.label": "Help",
  "help.title": "Help · {level}",
  "help.tabMap": "Map",
  "help.tabRules": "Rules",
  "help.mapHead": "What you can interact with",
  "help.go": "Got it",
  "help.reopen": "Press H or Help at the bottom to open this again. Time stops while it’s open.",
  "help.you": "YOU",
  "help.timeHead": "How time works",
  "help.idle": "Doing nothing",
  "help.idleWhen": "Every {sec} s",
  "help.idleOr": " (6 s during surgery)",
  "help.idleCost": "+1 min",
  "help.walk": "Walking",
  "help.walkWhen": "Costs nothing extra; the clock keeps running",
  "help.walkCost": "+0",
  "help.talk": "Saying something",
  "help.talkWhen": "The clock stops while they answer",
  "help.talkCost": "+1–2 min",
  "help.act": "Exams, procedures, orders",
  "help.actWhen": "The time each one takes shows next to the clock",
  "help.actCost": "+1–6 min",
  "help.pause": "Help, phone calls, event banners",
  "help.pauseWhen": "During these",
  "help.pauseCost": "Clock stops",
  "help.noWait": "Patients keep changing as time passes. They won’t wait for you.",
  "help.span": "This level starts at {start}; sign-out is at {end} at the latest.",
  "help.ctrlHead": "Controls",
  "help.ctrl1":
    "Arrow keys or WASD to move, Space to interact with what’s in front of you. You can also click a person or object on the map to walk there.",
  "help.ctrl2": "Yellow ▼: something in front of you that you can interact with.",
  "help.ctrl3": "Over someone’s head: a yellow “?” is waiting on you, a red “!” has news, a white “…” is talking.",
  "help.ctrl4": "Top left of the map: things people are waiting on you for. A countdown bar means a deadline.",
  "help.ctrl5": "Side panel: the conversation log, what you can do, and a box to talk to characters.",
  "help.ctrl6": "Walking up to a patient opens a close-up. Click the body or the equipment directly.",
  "help.rulesHead": "Special rules for this level",
  "help.legendSep": " · ",

  "end.label": "Ending",
  "end.code": "ENDING {code}",
  "end.reason": "Ending {code}: {name}",
  "end.toLevels": "Back to levels",
  "end.done": "Completed",
  "end.early": "Ended early",

  "fb.good": "Done",
  "fb.partial": "Partly",
  "fb.miss": "Missed",
  "fb.heading": "{name}’s feedback · {level}{ending}",
  "fb.ending": " · Ending {code}: {name}",
  "fb.best": "Best moment",
  "fb.next": "Next time",
  "fb.over": "Level over",
  "fb.failed": "The feedback didn’t come through. Here are the key points from your run.",
  "fb.writing": "{name} is reading through your run and writing feedback…",
  "fb.backToLog": "Back to the log",
  "fb.factSep": " / ",

  "err.noKey": "The server has no Claude API key set up, so characters can’t reply.",
  "err.quota":
    "Today’s conversation quota is used up, so characters can’t reply for now. Come back tomorrow, or end the level to see your feedback.",
  "err.noSession": "We couldn’t confirm you’re a human player (the check didn’t pass). Reload the page and try again.",
  "err.rate": "No answer for the moment (usage limit reached). Wait a bit and say it again.",
  "err.network": "The line cut out and they didn’t hear you. Try saying it again.",
} as const satisfies Record<keyof typeof zh, string>;

type Zh = typeof zh;
export type MsgKey = keyof Zh;

/** `{a} and {b}` → "a" | "b". */
type Params<S extends string> = S extends `${string}{${infer P}}${infer Rest}` ? P | Params<Rest> : never;
type Args<K extends MsgKey> = [Params<Zh[K]>] extends [never] ? [] : [vars: Record<Params<Zh[K]>, string | number>];

export const MESSAGES: {
  readonly zh: Readonly<Record<MsgKey, string>>;
  readonly en: Readonly<Record<MsgKey, string>>;
} = { zh, en };

const table: Readonly<Record<MsgKey, string>> = isEn ? en : zh;

/** Look up a UI string; placeholders are typed from the zh source. */
export function t<K extends MsgKey>(key: K, ...args: Args<K>): string {
  const s = table[key];
  const vars = args[0] as Record<string, string | number> | undefined;
  return vars ? s.replace(/\{(\w+)\}/g, (m, k: string) => (k in vars ? String(vars[k]) : m)) : s;
}
